import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { WizardEventData, EventCategory } from '../../create-event-wizard';
import { CountryResponse } from '../../../../../../../../@shared/models/response.module';
import { StaticService } from '../../../../../../../../@shared/services/static-service';

@Component({
  selector: 'app-wizard-step-basic',
  standalone: false,
  templateUrl: './wizard-step-basic.html',
  styleUrl: './wizard-step-basic.css'
})
export class WizardStepBasic implements OnInit {
  @Input() eventData: WizardEventData;
  @Input() showValidation = false;
  @Input() category: EventCategory | null = null;
  @Output() dataChange = new EventEmitter<Partial<WizardEventData>>();

  countries: CountryResponse[] = [];

  constructor(private staticService: StaticService) {}

  ngOnInit() {
    this.loadCountries();
  }

  loadCountries() {
    this.staticService.getCountries().subscribe({
      next: (countries) => {
        this.countries = countries;
      },
      error: (err) => {
        console.error('Failed to load countries', err);
      }
    });
  }

  currencyOptions = [
    { code: 'NOK', name: 'NOK' },
    { code: 'SEK', name: 'SEK' },
    { code: 'EUR', name: 'EUR' },
    { code: 'USD', name: 'USD' },
    { code: 'GBP', name: 'GBP' },
    { code: 'DKK', name: 'DKK' },
  ];

  disciplineOptions = [
    { value: 'distance', label: 'Distanse' },
    { value: 'dressage', label: 'Dressur' },
    { value: 'eventing', label: 'Feltritt' },
    { value: 'icelandic', label: 'Islandshest' },
    { value: 'driving', label: 'Kjøring' },
    { value: 'mounted_games', label: 'Mounted Games' },
    { value: 'para_dressage', label: 'Paradressur' },
    { value: 'jumping', label: 'Sprang' },
    { value: 'vaulting', label: 'Voltige' },
    { value: 'western', label: 'Western' },
    { value: 'barrel_racing', label: 'Barrel Racing' },
    { value: 'pole_bending', label: 'Pole Bending' },
    { value: 'reining', label: 'Reining' },
    { value: 'working_eq', label: 'Working Equitation' },
    { value: 'skeid', label: 'Skeid' },
    { value: 'equestrian', label: 'Riddesport' },
    { value: 'trotting', label: 'Trav' },
    { value: 'gallop', label: 'Galopp' },
    { value: 'polo', label: 'Polo' },
    { value: 'academic', label: 'Akademisk Ridekunst' },
    { value: 'exhibition', label: 'Utstilling' },
    { value: 'struk', label: 'STRUK' },
    { value: 'other', label: 'Annet' }
  ];

  emitChange(partial: Partial<WizardEventData>) {
    this.dataChange.emit(partial);
  }

  isFieldInvalid(field: 'event_name' | 'discipline' | 'start_date' | 'end_date' | 'address' | 'postal_code' | 'city' | 'country_id'): boolean {
    if (!this.showValidation) return false;
    // Discipline is optional for social events
    if (field === 'discipline' && this.category === 'social') {
      return false;
    }
    return !this.eventData[field];
  }

  get isDisciplineRequired(): boolean {
    return this.category !== 'social';
  }

  isEndDateInvalid(): boolean {
    if (!this.showValidation) return false;
    if (!this.eventData.end_date) return true;
    if (this.eventData.start_date && this.eventData.end_date) {
      return new Date(this.eventData.end_date) < new Date(this.eventData.start_date);
    }
    return false;
  }

  isRegistrationDeadlineInvalid(): boolean {
    if (!this.showValidation) return false;
    if (!this.eventData.registration_deadline) return false;
    if (this.eventData.start_date && this.eventData.registration_deadline) {
      return new Date(this.eventData.registration_deadline) > new Date(this.eventData.start_date);
    }
    return false;
  }

  onLogoChange(files: File[]) {
    this.emitChange({ logo: files[0] });
  }

  onHeaderChange(files: File[]) {
    this.emitChange({ header: files[0] });
  }
}
